import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from './contexts/AuthContext';
import { OrganisationProvider } from './contexts/OrganisationContext';
import { ContractProvider } from './contexts/ContractContext';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import SessionExpiredModal from './components/SessionExpiredModal';

// Global styles
import './index.css';

console.log("frontend build config", {
  keycloakUrl: process.env.REACT_APP_KEYCLOAK_URL,
  keycloakRealm: process.env.REACT_APP_KEYCLOAK_REALM,
  keycloakClientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});


// Add IDS theme classes to <body> before React renders
document.body.classList.add('ids--inera', 'ids--light');

// Create root React rendering target
const root = ReactDOM.createRoot(document.getElementById('root'));

/**
 * Application entry point.
 * Uses React Router to define page navigation.
 */
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <OrganisationProvider>
          <ContractProvider>
            <Header />
            <div className="app-content">
              <AppRoutes />
            </div>
            <Footer />
            <SessionExpiredModal />
          </ContractProvider>
        </OrganisationProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
